import { gql } from "@apollo/client";

export const USER_QUESTIONNAIRE_REPORT_QUERY = gql`
  query UserQuestionnaireReport($userId: ID!, $organisationId: ID!) {
    userQuestionnaireReport(userId: $userId, organisationId: $organisationId) {
      hasAnswers
      submittedAt
      additionalInformation
      userQuestions {
        id
        question {
          text
        }
        answerText
        answerScore
      }
    }
    user(userId: $userId, organisationId: $organisationId) {
      id
      isActive
      patientProfile {
        id
        isWard
        guardian {
          id
          user {
            id
            isActive
          }
        }
      }
    }
  }
`;

export const REQUEST_QUESTIONNAIRE_MUTATION = gql`
  mutation RequestQuestionnaireMutation($input: RequestQuestionnaireMutationInput!) {
    requestQuestionnaireMutation(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;
